import { AuthRoutes } from 'src/features/auth';

export const publicRoutes = [
    {
        path: '/*',
        element: <AuthRoutes />,
    },
];
